module.exports = __webpack_public_path__ + "img/video_image.73562fbb.png";